import React from 'react';

const LoadingSpinner = ({ size = 'md', color = 'teal' }) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-12 w-12',
    lg: 'h-16 w-16'
  };

  const colorClasses = {
    teal: 'border-teal-500',
    amber: 'border-amber-500',
    green: 'border-green-500',
    blue: 'border-blue-500'
  };

  return (
    <div className="flex items-center justify-center min-h-[200px]">
      <div 
        className={`animate-spin rounded-full border-b-2 ${sizeClasses[size]} ${colorClasses[color]}`}
      />
    </div>
  );
};

export default LoadingSpinner;
